import FilterBase from "./filterBase.js";

export default class Blur extends FilterBase {
    objectType = "BlurFilterItem";

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        if (args.tooltip == null) {
            args.tooltip = "Applique un flou à l'image";
        }
        super.objectToClassValue(args);
    }

    static get Name() {
        return "Blur";
    }

    async filterAction(cv, cvImage) {
        cv.blur(cvImage, cvImage, new cv.Size(9, 9), new cv.Point(-1, -1));
        return cvImage;
    }
}